import Blogs from './Blog'
(function () {
    const $blogListings = document.querySelectorAll('.blog-listing')
    if ($blogListings.length) $blogListings.forEach($bl => {
        if(!$bl.classList.contains('blog-listing--ui')) new Blogs.BlogListing($bl)
    })
})()